import { paragraphCss, detailsSmallCss, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: rgb(25 61 75);
  z-index: 99;
  display: flex;
  justify-content: space-around;
  padding: 30px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    display: block;
    text-align: center;
  }
`;

const Paragraph = styled(paragraph)`
  color: white;
  margin: auto 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 0 auto 20px auto;
  }
`;

const A = styled.a`
  ${paragraphCss}
  margin-left: 5px;
  color: white;
  text-decoration: none;
  position: relative;
  display: inline-block;

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.textColors.secondary};
    bottom: 5%;
    transition: all 0.2s ease;
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover::after {
      background: ${(props) => props.theme.textColors.primary};
    }
  }
`;

const CloseModal = styled.button`

`;

const Button = styled.button`
  ${detailsSmallCss}
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  padding: 20px 48px 16px 48px;
  color: ${({ theme }) => theme.textColors.secondary};
  border: ${({ theme }) => theme.textColors.secondary} 2px solid;
  background: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  white-space: nowrap;
  text-align: center;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: white;
      color: ${({ theme }) => theme.colors.primary};
      border: ${({ theme }) => theme.textColors.secondary} 2px solid;
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    ${detailsSmallCss}
    height: 41px;
    max-width: 100%;
    width: 100%;
  }
`;

const S = {
  Container,
  Paragraph,
  A,
  Button,
  CloseModal,
};

export default S;
